export const DELETE_USER = 'lumahealth/DialogDeleteUser/DELETE_USER';
export const DELETE_USER_ERROR = 'lumahealth/DialogDeleteUser/DELETE_USER_ERROR';
export const DELETE_USER_SUCCESS = 'lumahealth/DialogDeleteUser/DELETE_USER_SUCCESS';

export const GET_USER_GROUPS = 'lumahealth/DialogDeleteUser/GET_USER_GROUPS';
export const GET_USER_GROUPS_ERROR = 'lumahealth/DialogDeleteUser/GET_USER_GROUPS_ERROR';
export const GET_USER_GROUPS_SUCCESS = 'lumahealth/DialogDeleteUser/GET_USER_GROUPS_SUCCESS';

export const FORM_NAME = 'DialogDeleteUserForm';

export const RESET_SELECTORS = 'lumahealth/DialogDeleteUser/RESET_SELECTORS';
